export interface GradeTagProps {
  grade: string;
  size?: 'sm' | 'md' | 'lg';
  neutral?: boolean;
}

const GRADE_COLORS: Record<string, string> = {
  A: '#f3f3f3',
  B: '#5AE9FF',
  C: '#FFF981',
  D: '#FF9A4D',
  F: '#DB5282',
};

// A letter grade as a square tag (Tradehaus .tx-pill shape: a rounded square, never a capsule). Neutral sits on the
// theme's fill in its ink; otherwise the grade's colour tints the fill and inks the letter
const SIZES = {
  sm: { side: 18, radius: 5, fontSize: 10 },
  md: { side: 22, radius: 6, fontSize: 12 },
  lg: { side: 26, radius: 7, fontSize: 13 },
} as const;

export const GradeTag = ({ grade, size = 'md', neutral = false }: GradeTagProps) => {
  const { side, radius, fontSize } = SIZES[size];
  const color = neutral ? 'var(--tx-text)' : (GRADE_COLORS[grade] ?? 'var(--tx-muted)');

  return (
    <span
      style={{
        display: 'inline-grid',
        placeItems: 'center',
        width: side,
        height: side,
        borderRadius: radius,
        background: neutral ? 'var(--tx-fill-2)' : `${GRADE_COLORS[grade] ?? '#8a8580'}1f`,
        color,
        fontSize,
        fontWeight: 600,
        lineHeight: 1,
        fontFamily: "'Manrope', sans-serif",
      }}>
      {grade}
    </span>
  );
};

export default GradeTag;
